<template>
    <fb-main-body>
        <tree-form>

            <template slot="tree">
                <fb-scrollbar>
                    <el-tree :expand-on-click-node="false" ref="tree" :props="defaultProps" :highlight-current="true" node-key="code" :load="loadData"
                             @node-click="handleNodeClick" lazy>
                    </el-tree>
                </fb-scrollbar>

            </template>

            <template slot="btn-group">
                <el-button-group style="display: inline-block">
                    <el-button @click.stop="handleAddBrother" size="mini"
                               :disabled="!currentNode || currentNode.level === 1">
                        新增同级节点
                    </el-button>
                    <el-button @click="handleAddChild" size="mini" :disabled="!currentNode">新增子节点
                    </el-button>
                    <el-button @click="handleDeleteNode" size="mini"
                               :disabled="!currentNode || currentNode.level === 1">删除此节点
                    </el-button>
                </el-button-group>
            </template>

            <template slot="form">

                <el-form v-if="currentNode && currentNode.level !== 1" ref="form" :model="currentNode.data"
                         :rules="formRules" label-width="80px"
                         style="max-width: 300px;">

                    <el-form-item label="模块名称" prop="name" :error="formErrorMsg.name">
                        <el-input v-model="currentNode.data.name"></el-input>
                    </el-form-item>


<!--                    <el-form-item label="模块编号" prop="number" :error="formErrorMsg.number">-->
<!--                        <el-input v-model="currentNode.data.number" :disabled="true" placeholder="00000000"></el-input>-->
<!--                    </el-form-item>-->

                    <el-form-item label="排序" prop="sortNum" :error="formErrorMsg.number">
                        <el-input v-model="currentNode.data.sortNum"></el-input>
                    </el-form-item>

                    <el-form-item label="上级模块">
                        <el-input :value="parentName" :disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="handleSaveData" :disabled="currentNode.data.$saveStatus">保存
                        </el-button>
                    </el-form-item>
                </el-form>

                <div v-else style="line-height: 100%">
                    请选择操作节点
                </div>

            </template>


        </tree-form>
    </fb-main-body>
</template>

<script>
    import TreeForm from "../../components/TreeForm";

    export default {
        name: "Index",
        components: {TreeForm},
        watch: {
            'currentNode.data': {
                deep: true,
                handler: function (n, o) {
                    if (n && o) {

                        if(n.$action === 'saveFinish'){
                            delete  n.$action;
                           return ;
                        }

                        if (n.$treeNodeId === o.$treeNodeId) {

                            n.$saveStatus = false;
                            if (!n.$action) {
                                n.$action = 'update';
                            }
                        }else{

                            if(!o.$saveStatus){

                                this.$message({
                                    message: '请先保存当前表单信息，再进行次操作',
                                    type: 'warning'
                                });

                                this.$refs['tree'].setCurrentKey(o.code);
                                this.currentNode = this.$refs['tree'].getNode(this.$refs['tree'].getCurrentNode());


                            }

                        }
                    }
                }
            }
        },
        data() {
            return {
                currentNode: null,
                formErrorMsg: {name: '', number: ''},
                formRules:
                    {
                        name: [
                            {required: true, message: '模块名称不能为空', trigger: 'blur'},
                        ]
                    }
                ,
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    isLeaf: 'leaf'
                }
            };
        },
        computed: {
            parentName() {

                if (this.currentNode) {

                    let concat = function (node) {
                        if (node.parent) {
                            let pName = concat(node.parent)
                            return (pName ? (pName + " / ") : '') + (node.parent.data ? node.parent.data.name : '');
                        } else {
                            return '';
                        }

                    };

                    return concat(this.currentNode);
                } else {
                    return '';
                }
            }
        },
        methods: {
            handleAddChild() {


                if (this.currentNode && !this.currentNode.data.$saveStatus) {
                    this.$message({
                        message: '请先保存当前表单信息，再进行次操作',
                        type: 'warning'
                    });
                    return;
                }

                let vm = this;
                let code = new Date().getTime();
                let data = {
                    name: '新增模块',
                    parentCode: vm.currentNode.data.code,
                    number: '',
                    code: code,
                    $saveStatus: false,
                    leaf: false,
                    $action: 'add',
                    $add: true
                };
                vm.$refs['tree'].append(data, vm.currentNode);
                vm.$nextTick(() => {
                    vm.$refs['tree'].setCurrentKey(code);
                    vm.currentNode = vm.$refs['tree'].getNode(vm.$refs['tree'].getCurrentNode());
                    console.log(vm.currentNode);
                })

            },
            handleAddBrother() {

                let vm = this;

                if (this.currentNode && !this.currentNode.data.$saveStatus) {
                    this.$message({
                        message: '请先保存当前表单信息，再进行次操作',
                        type: 'warning'
                    });
                    return;
                }

                let code = new Date().getTime();

                let data = {
                    name: '新增模块',
                    parentCode: vm.currentNode.parent.data.code,
                    number: '',
                    code: code,
                    $saveStatus: false,
                    $action: 'add'
                };
                vm.$refs['tree'].insertAfter(data, vm.currentNode);
                vm.$nextTick(() => {
                    vm.$refs['tree'].setCurrentKey(code);
                    vm.currentNode = vm.$refs['tree'].getNode(vm.$refs['tree'].getCurrentNode());
                })


            },
            handleDeleteNode() {

                //发生删除请求
                let vm = this;

                if (vm.currentNode.data.$action === 'add') {
                    vm.$refs['tree'].remove(vm.currentNode);
                    vm.currentNode = null;
                    return;
                }

                vm.$http.post(vm.$api.module.delete, vm.$qs.stringify({code: vm.currentNode.data.code})).then((resp) => {

                    if (resp.data.status === 200) {
                        vm.$message({type: 'success', message: resp.data.desc});
                        vm.$refs['tree'].remove(vm.currentNode);
                        vm.currentNode = null;
                    } else {
                        vm.$message({type: 'error', message: resp.data.desc});
                    }

                });

            },
            handleNodeClick(data, node) {
                this.currentNode = node;
            },
            loadData(node, resolve) {

                let vm = this;

                if (node.level === 0) {
                    resolve([{name: '根模块', disabled: true, $saveStatus: true}]);
                    return;
                }

                vm.$http.post(vm.$api.module.list, vm.$qs.stringify({
                    root: !node.data.code,
                    parentCode: node.data.code,
                    onPage: false
                })).then((resp) => {
                    resp.data.data.modules.forEach((e) => {
                        e.$saveStatus = true;
                    });
                    resolve(resp.data.data.modules.concat(node.data.children ? node.data.children.filter((e) => {
                        return !e.saveStatus
                    }) : []));
                });


            },
            handleSaveData() {

                let vm = this;


                vm.$refs['form'].validate((valid) => {

                    if (valid) {


                        let handleResp = function (resp) {
                            if (resp.data.status === 200) {

                                delete vm.currentNode.data.$action;
                                vm.currentNode.data.code = resp.data.data.code;
                                vm.$nextTick(() => {
                                    vm.currentNode.data.$saveStatus = true;
                                    vm.currentNode.data.$action = 'saveFinish';
                                });
                                vm.$message({type: 'success', message: resp.data.desc});
                            } else if (resp.data.status === 400) {

                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });

                                });

                                if (resp.data.desc) vm.$message({type: 'error', message: resp.data.desc});
                            } else {
                                if (resp.data.desc) vm.$message({type: 'error', message: resp.data.desc});
                            }
                        };


                        let data = JSON.parse(JSON.stringify(vm.currentNode.data));

                        delete data.$action;
                        delete data.$saveStatus;
                        delete data.updateTime;
                        delete data.createTime;

                        //判断是新增还是更新
                        if (vm.currentNode.data.$action === 'add') {
                            delete data.code;

                            vm.$http.post(vm.$api.module.add, vm.$qs.stringify(data)).then(handleResp);
                        } else if (vm.currentNode.data.$action === 'update') {

                            vm.$http.post(vm.$api.module.update, vm.$qs.stringify(data)).then(handleResp);

                        }

                    }

                });


            }
        },
        mounted() {
            // this.$refs['tree'].setCurrentKey(this.$refs['tree'].getNode(this.data[0]));

        }
    }
</script>

<style lang="scss" scoped>



</style>